import React from "react";
class MapAcadiaNationalPark extends React.Component {
  render() {
    return (
      <React.Fragment>
        <section id="map-acadia-national-park" className="about-us gray-light-bg">
          <iframe
            src="https://maps.google.com/maps?saddr=Bar+Harbor,+ME&daddr=Acadia+National+Park+Visitor+Center,+ME+to:Sand+Beach,+Acadia,+ME+to:Thunder+Hole,+Acadia,+ME+to:Cadillac+Mountain,+ME+to:Jordan+Pond,+Acadia,+ME+to:Bass+Harbor+Head+Lighthouse,+ME&output=embed"
            width="100%"
            height="420"
            title="Acadia National Park route map">
          </iframe>
        </section>
      </React.Fragment>
    );
  }
}
export default MapAcadiaNationalPark;
